<template>
  <div>
    <v-card-title>
      <h3 class="headline my-0">{{ $t('Datos del trabajador/a') }}</h3>
    </v-card-title>
    <v-divider light></v-divider>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-model="formData.fullname"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Nombre y apellidos del trabajador/a')"
            :rules="[rules.required]"
            required
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pr-3>
          <v-text-field
            v-model="formData.nif"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('DNI/NIE')"
            :rules="[rules.required, rules.dniNie]"
            required
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pr-3>
          <v-text-field
            v-model="formData.num_ss"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Nº Afiliación Seguridad Social')"
            box
          ></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-menu
            v-model="showRequestDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            :disabled="disabled"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                ref="date"
                :rules="[rules.required]"
                v-model="formattedBirthdate"
                class="pr-2"
                :label="$t('Fecha de nacimiento')"
                readonly
                mask="date"
                v-on="on"
                box
                @input="$emit('input', formData)"
                :disabled="disabled"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.birthdate"
              @input="showRequestDatePicker = false"
              locale="es"
              first-day-of-week="1"
              :reactive="true"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-model="formData.address"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Dirección')"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs5 pr-3>
          <v-text-field
            v-model="formData.city"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Ciudad')"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs5 pr-3>
          <v-text-field
            v-model="formData.province"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Provincia')"
            :rules="[rules.required]"
            required
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="formData.cp"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('CP')"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pr-3>
          <v-text-field
            v-model="formData.nationality"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Nacionalidad')"
            :rules="[rules.required]"
            required
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pr-3>
          <v-text-field
            v-model="formData.phone"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Teléfono')"
            :rules="[rules.required]"
            required
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model="formData.email"
            :disabled="disabled"
            @input="$emit('input', formData)"
            :label="$t('Email')"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs6></v-flex>
      </v-layout>
    </v-card-text>
  </div>
</template>

<script>
const moment = require('moment');

export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          fullname: null,
          nif: null,
          num_ss: null,
          birthdate: null,
          address: null,
          city: null,
          province: null,
          cp: null,
          nationality: null,
          phone: null,
          email: null,
        };
      },
    },
  },
  data() {
    return {
      showRequestDatePicker: false,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        dniNie: value => {
          const pattern1 = /^(([A-Z]{1}|[a-z]{1})([0-9]){7})([0-9])?-?([A-Z]{1}|[a-z]{1})$/;
          const pattern2 = /^(([0-9]){7})([0-9])?-?([A-Z]{1}|[a-z]{1})$/;
          const pattern3 = /^(([A-Z]{1}|[a-z]{1})-?([0-9]){8})$/;
          const pattern4 = /^(([A-Z]{1}|[a-z]{1})-?([0-9]){8})$/;
          return (
            pattern1.test(value) ||
            pattern2.test(value) ||
            pattern3.test(value) ||
            pattern4.test(value) ||
            'DNI/NIE inválido'
          );
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formattedBirthdate: {
      get() {
        return this.formData.birthdate ? moment(this.formData.birthdate).format('DD/MM/YYYY') : '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
